import { FC } from 'react';
import { Grid, Typography, Box, useMediaQuery } from '@mui/material';
import useTranslations from '../global/translation/hooks/translation';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';

const TrustProof: FC = () => {
  const { currentLanguage, translations } = useTranslations();
  const theme = useTheme();
  const { darkMode } = useThemeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const metrics = translations.label.proofMetrics[currentLanguage].split('|').map((m) => m.trim());

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        bgcolor: darkMode ? '#232323' : '#F5F5F5',
        py: isMobile ? 5 : 8,
        px: isMobile ? 3 : 4,
      }}
    >
      <Grid container spacing={isMobile ? 3 : 4} sx={{ maxWidth: '1000px', mx: 'auto' }}>
        {metrics.map((metric, index) => {
          // Extract the number and label
          const parts = metric.match(/^([^a-zA-Z]*)(.*)/);
          const number = parts?.[1] || '';
          const label = parts?.[2] || metric;

          return (
            <Grid item xs={12} sm={6} md={4} key={index} sx={{ textAlign: 'center' }}>
              <Box sx={{ py: 1 }}>
                <Typography
                  variant="h4"
                  fontWeight={400}
                  sx={{
                    color: theme.palette.primary.main,
                    mb: 1,
                    letterSpacing: '-0.5px',
                  }}
                >
                  {number}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: darkMode ? '#CCCCCC' : '#555555',
                    fontSize: '14px',
                    lineHeight: 1.5,
                  }}
                >
                  {label}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default TrustProof;
